import React from 'react';
import { STAGES } from './fleetConstants';

function FleetTabs({ activeTab, onTabSwitch, tabCounts }) {
  return (
    <div className="fleet-tabs">
      {Object.values(STAGES).map(stage => (
        <button
          key={stage.key}
          className={`fleet-tab ${activeTab === stage.key ? 'fleet-tab-active' : ''}`}
          style={{ '--tab-color': stage.color }}
          onClick={() => onTabSwitch(stage.key)}
        >
          {stage.label} <span className="fleet-tab-count">{tabCounts[stage.key] || 0}</span>
        </button>
      ))}
    </div>
  );
}

export default FleetTabs;
